import { RefObject, createContext, useContext } from 'react';
import { ScrollView } from 'react-native';

export const FormScrollContext = createContext<RefObject<ScrollView> | null>(null);

export function useFormScrollContext() {
  return useContext(FormScrollContext);
}
